import React from "react";
import { useIsMobile } from "../../../../Hooks";

import useStyles from "./FmBestSolution.style";

interface BestSolutionProps {
    leftText: string | null;
    centerText: string | null;
    rightText: string | null;
}

const BestSolution = ({ leftText, centerText, rightText }: BestSolutionProps) => {
    const classes = useStyles();
    const isMobile = useIsMobile();

    return (
        <div className={isMobile ? classes.mobile_container : classes.container}>
            <span className={isMobile ? classes.mobile_leftText : classes.leftText}>{leftText}</span>
            <span className={isMobile ? classes.mobile_centerText : classes.centerText}>{centerText}</span>
            <span className={isMobile ? classes.mobile_rightText : classes.rightText}>{rightText}</span>
        </div>
    );
};

export default BestSolution;
